<template>
  <div class="tw-flex tw-flex-col sm:tw-items-center tw-justify-center tw-min-h-screen tw-bg-gray-100">
    <base-card shadow no-padding class="tw-w-full sm:tw-max-w-md">
      <div class="tw-py-4 tw-flex tw-justify-center">
        <component :is="logo" class="tw-w-3/4 tw-max-h-32" />
      </div>
      <base-content>
        <div class="tw-mb-2 tw-text-lg tw-text-center">Success!</div>
        <p class="tw-text-600 tw-text-sm tw-text-center">
          Check your email for a link to verify your account.
        </p>
        <base-button type="primary" class="tw-w-full tw-mt-4" @click="href('/signin')">Sign In</base-button>
      </base-content>
    </base-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PredictileLogo from "@/assets/images/predictile-logo-square.svg";

export default {
  name: "BusinessSignUpSuccessView",
  components: {
    PredictileLogo,
  },
  computed: {
    ...mapGetters("organization", ["cobrandId"]),
    logo() {
      return "predictile-logo";
    },
  },
  methods: {
    href(path) {
      this.$router.push(path);
    },
  },
};
</script>
